import { render, staticRenderFns } from "./BankInformation.vue?vue&type=template&id=4d244f46&"
import script from "./BankInformation.vue?vue&type=script&lang=js&"
export * from "./BankInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports